import CustomAlertManager from './CustomAlertManager';
import oktaAuthentication from "../okta/oktaAuth";
import { useRef, useEffect } from 'react';

function Home() {
    const titleRef = useRef();
    const okta  = oktaAuthentication;
/*    var vAccessToken = okta.getAccessToken();*/

    useEffect(() => {
        const authenticationMethod = async () => {
            if (okta.isLoginRedirect()) {
                try {
                    await okta.handleRedirect();
                } catch (e) {
                    // log or display error details
                }
            } else if (!await okta.isAuthenticated()) {
                // Start the browser based oidc flow, then parse tokens from the redirect callback url
                okta.signInWithRedirect();
            } else {
                titleRef.current = await okta.isAuthenticated();
            }
        }

        authenticationMethod();
    }, [okta]);

    if (!titleRef) {
        return null;
    }

    return (
        <CustomAlertManager />
    );

    //if (okta.isLoginRedirect()) {
    //    if (vAccessToken == null) {
    //        // User is authenticated
    //        return (
    //            <CustomAlertManager />
    //        );
    //    }
    //} else {
    //    if (vAccessToken == null) {
    //        // User is not authenticated
    //        // Redirect to Okta sign-in page
    //        okta.signInWithRedirect();
    //    }
    //    else {
    //        // User is authenticated
    //        return (
    //            <CustomAlertManager />
    //        );
    //    }
    //}
} export default Home;
